import React, { Component } from 'react';
import { compose, withProps } from "recompose";
import { connect } from 'react-redux';

import Aux from '../../hoc/Auxiliary/Auxiliary';
import Spinner from '../../components/UI/Spinner/Spinner';
import logError from '../../store/LogError';
import axios from '../../axios-trips';
import * as actionTypes from '../../store/actions';
import classes from './TripTracking.css';
import Tracking from './Tracking/Tracking';
import homeGreenIcon from '../../assets/images/home-green-small-icon.png';
import storeIcon from '../../assets/images/store-small-icon.png';
import storeGreenIcon from '../../assets/images/store-small-green-icon.png';
import storeBlueIcon from '../../assets/images/store-small-blue-icon.png';
import TripModal from '../../components/TripModal/TripModal';
import Modal from '../../components/UI/Modal/Modal';
import Button from '../../components/UI/Button/Button';
import TripTrackingModal from '../../components/TripTrackingModal/TripTrackingModal';
import Account from '../Account/Account';
import Map from '../../components/Map/Map';

class TripTracking extends Component {

  state = {
    loading: false,
    tracking: null,
    showTripTrackingModal: false,
    regions: ["NONE", "ЛЬВІВ", "ВІННИЦЯ", "КИЇВ", "ХАРКІВ", "ДНІПРО", "ОДЕСА", "ІМПОРТ"],
    regionToIndex: {"NONE": -1, "ЛЬВІВ":1, "ВІННИЦЯ":2, "КИЇВ":3, "ХАРКІВ":4, "ДНІПРО":5, "ОДЕСА":6, "ІМПОРТ":7},
    selectedTrip: null,
    selectedTripTracking: null,
    valueToCopy: "",
    showMap: false,
    mapLocations: [],
    mapPoints: [],
    mapOrigin: null
  }

  componentDidMount() {
    this.getTripTrackings();
  }

  getTripTrackings() {
    axios({
      method: 'get',
      url: '/api/v1/trip-tracking',
      headers: {'Authorization': 'Bearer ' + this.props.access_token}
    })
    .then(response => {
      const tripTracking = {};
      const data = response.data;
      for (let i = 0; i < response.data.length; i++) {
        const receivedTrTracking = {...response.data[i]};
        receivedTrTracking.tripTrackings.sort((a, b) => a.sort - b.sort)
        tripTracking[response.data[i].id] = receivedTrTracking;
      }
      this.setState({ tracking: tripTracking });
    })
    .catch(error => {
      console.log(error);
      setTimeout(() => this.getTripTrackings() ,1250);
      if (error.response) {
        logError(
          this.props.access_token,
          this.props.codeToMessage[error.response.status],
          '/api/v1/trip-tracking'
        );
        this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
      }
    });
  }

  updatePointStatusHandler(ev, trackId, status, index) {
    const updatedTracks = {...this.state.tracking};
    if (status > 1) {
      for (let i = 0; i < index; i++) {
        updatedTracks[trackId].tripTrackings[i].status = 3;
      }
      if (!updatedTracks[trackId].transportCode && index >= 1) {
        updatedTracks[trackId].tripTrackings[0].status = 4;
      }
    }

    for (let i = updatedTracks[trackId].tripTrackings.length - 1; i > index; i--) {
      if (updatedTracks[trackId].tripTrackings[i].status !== 1) {
        updatedTracks[trackId].tripTrackings[i].status = 0;
      }
    }
    updatedTracks[trackId].tripTrackings[index].status = status;
    this.setState({ tracking: updatedTracks });
  }

  getTodayDate() {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate());
    let date = tomorrow.getFullYear() + "-";
    if (tomorrow.getMonth() < 10) {
      date += "0";
    }
    date += (tomorrow.getMonth() + 1) + "-";
    if (tomorrow.getDate() < 10) {
      date += "0"
    }
    date += tomorrow.getDate();
    return date;
  }

  updateDateHandler(ev, trackId, index) {
    const updatedTracks = {...this.state.tracking};
    if (ev.target.value === null) {
      updatedTracks[trackId].tripTrackings[index].forecast = null;
    } else {
      updatedTracks[trackId].tripTrackings[index].forecast = ev.target.value + "T" + (updatedTracks[trackId].tripTrackings[index].forecast ? updatedTracks[trackId].tripTrackings[index].forecast.substring(11, 16) : "00:00");
    }
    this.setState({ tracking: updatedTracks });
  }

  updateTimeHandler(ev, trackId, index) {
    const updatedTracks = {...this.state.tracking};
    if (ev.target.value === null || ev.target.value === "") {
      updatedTracks[trackId].tripTrackings[index].forecast = null;
    } else {
      updatedTracks[trackId].tripTrackings[index].forecast = (updatedTracks[trackId].tripTrackings[index].forecast ? updatedTracks[trackId].tripTrackings[index].forecast.substring(0, 10) : this.getTodayDate()) + "T" + ev.target.value.substring(0, 2) + ":" + ev.target.value.substring(2, 4);
    }
    this.setState({ tracking: updatedTracks });
  }

  updateUnloadedHandler(ev, trackId) {
    const updatedTracks = {...this.state.tracking};
    if (ev.target.value === null) {
      updatedTracks[trackId].unloaded = null;
    } else {
      updatedTracks[trackId].unloaded = ev.target.value;
    }
    this.setState({ tracking: updatedTracks });
  }

  getYesterdayDate() {
    var date = new Date();
    date.setDate(date.getDate() - 2);
    return date;
  }

  forceUnloadHandler(trackId) {
    const updatedTracks = {...this.state.tracking};
    if (!updatedTracks[trackId].sent) {
      updatedTracks[trackId].sent = this.getYesterdayDate();
    }
    updatedTracks[trackId].unloaded = updatedTracks[trackId].sent;
    this.setState({ tracking: updatedTracks });
    this.updateTripTrackingStatus(updatedTracks[trackId], trackId, true);
  }

  updateCrash(ev, trackId, index) {
    const updatedTracks = {...this.state.tracking};
    updatedTracks[trackId].tripTrackings[index].crash = ev.target.checked;
    this.setState({ tracking: updatedTracks });
  }

  updateComment(ev, trackId, index) {
    const updatedTracks = {...this.state.tracking};
    updatedTracks[trackId].tripTrackings[index].comment = ev.target.value;
    this.setState({ tracking: updatedTracks });
  }

  updateTripTrackingStatus(tripTrackingStatus, trackId, remove=false) {
    if (tripTrackingStatus.transportCode) {
      axios({
        method: 'post',
        url: '/api/v1/trip-tracking',
        data: tripTrackingStatus,
        headers: {'Authorization': 'Bearer ' + this.props.access_token}
      })
      .then(response => {
        this.props.addNotification("Отслеживание рейса успешно обновлено.", "Success");
        if (remove) {
          const updatedTracks = {...this.state.tracking};
          delete updatedTracks[trackId];
          this.setState({ tracking: updatedTracks });
        } else {
          const updatedTracks = {...this.state.tracking};
          updatedTracks[trackId] = response.data;
          this.setState({ tracking: updatedTracks });
        }
      })
      .catch(error => {
        console.log(error);
        if (error.response) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/trip-tracking'
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        }
      });
    } else {
      axios({
        method: 'post',
        url: '/api/v1/import-tracking',
        data: tripTrackingStatus,
        headers: {'Authorization': 'Bearer ' + this.props.access_token}
      })
      .then(response => {
        this.props.addNotification("Отслеживание импортного рейса успешно обновлено.", "Success");
        if (remove) {
          const updatedTracks = {...this.state.tracking};
          delete updatedTracks[trackId];
          this.setState({ tracking: updatedTracks });
        } else {
          const updatedTracks = {...this.state.tracking};
          updatedTracks[trackId] = response.data;
          this.setState({ tracking: updatedTracks });
        }
      })
      .catch(error => {
        console.log(error);
        if (error.response) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/trip-tracking'
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        }
      });
    }
  }

  tripIdChanged(ev, trackId) {
    ev.preventDefault();
    const updatedTracks = {...this.state.tracking};
    if (ev.target.value === "-") {
      updatedTracks[trackId].trip = null;
    } else {
      const updatedRoutes = [...this.props.routes];
      for (let i = 0; i < this.props.routes.length; i++) {
        if (this.props.routes[i].id === parseInt(ev.target.value, 10)) {
          updatedTracks[trackId].trip = this.props.routes[i];
          if (this.props.routes[i].carrierConfirmed) {
            this.archiveTrip(this.props.routes[i].id);
          }
          break;
        }
      }
    }
    this.updateTripTrackingStatus(updatedTracks[trackId], trackId);
  }

  archiveTrip = (id) => {
    this.setState({ loading: true });
    axios({
      method: 'post',
      url: '/api/v1/trips/archive?id=' + id,
      headers: {'Authorization': 'Bearer ' + this.props.access_token},
    })
    .then(response => {
      console.log(response);
      this.props.addNotification("Рейс был заархивирован.", "Success");
    })
    .catch(error => {
      console.log(error);
      this.setState({ loading: false });
      if (error.response) {
        logError(
          this.props.access_token,
          this.props.codeToMessage[error.response.status],
          '/api/v1/trips/archive?id=' + id
        );
        this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
      }
    });
  }

  findTripRegion(routeId) {
    for (let i = 0; i < this.props.routes.length; i++) {
      if (parseInt(this.props.routes[i].id, 10) === parseInt(routeId, 10)) {
        return this.props.locations[this.props.routes[i].origin].region;
      }
    }
    return null;
  }

  constructCard = (trip, driverId) => {
    let localRequests = [];
    this.props.requests.forEach(request => {
      if (request.tripId === parseInt(trip.id, 10)) {
        localRequests.push({...request});
      }
    });

    let card = {
      id: "T" + trip.id,
      tripPoints: trip.tripPoints,
      tripDate: trip.tripDate,
      capacity: trip.capacity,
      price: trip.price,
      priceComment: trip.priceComment,
      priceConfirmed: trip.priceConfirmed,
      priority: trip.priority,
      driver: driverId,
      car: trip.car,
      carrierId: trip.carrierId,
      carrierOkpo: trip.carrierOkpo,
      carrierName: trip.carrierName,
      carrierLs: trip.carrierLs,
      carrierConfirmed: trip.carrierConfirmed,
      managers: trip.managers ? trip.managers : [],
      note: trip.note,
      dispatcher: trip.dispatcher,
      archived: trip.archived,
      requests: localRequests
    };

    console.log("Created card with id: " + card.id);

    return card;
  }

  openTrip(ev, tripId, tripTracking, driverId) {
    ev.preventDefault();
    let foundTrip = false;
    for (let i = 0; i < this.props.routes.length; i++) {
      if (this.props.routes[i].id === tripId) {
        this.props.onSetTripleMode(true);
        this.setState({ selectedTripTracking: tripTracking,
                        showTripTrackingModal: true,
                        selectedTrip: this.constructCard(this.props.routes[i], driverId)});
        foundTrip = true;
      }
    }
    if (!foundTrip) {
      axios({
        method: 'get',
        url: '/api/v1/trips/trip?id=' + tripId,
        headers: {'Authorization': 'Bearer ' + this.props.access_token}
      })
      .then(response => {
        this.props.onSetTripleMode(true);
        const updatedRoutes = [...this.props.routes];
        updatedRoutes.push(response.data);
        this.props.onSetRoutes(updatedRoutes);
        this.setState({ selectedTripTracking: tripTracking,
                        showTripTrackingModal: true,
                        selectedTrip: this.constructCard(response.data, driverId)});
      })
      .catch(error => {
        console.log(error);
        setTimeout(() => this.getTripTrackings() ,1250);
        if (error.response) {
          logError(
            this.props.access_token,
            this.props.codeToMessage[error.response.status],
            '/api/v1/trips/trip?id=' + tripId
          );
          this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
        }
      });
    }
  }

  findLocationById(locationId) {
    for (let key in this.props.locations) {
      if (this.props.locations[key].id === locationId) {
        return this.props.locations[key];
      }
    }

    return null;
  }

  closeTripTrackingModal = (ev) => {
    this.setState({ showTripTrackingModal: false, selectedTrip: null })
    this.props.onSetTripleMode(false);
  }

  transformPoint(point, name) {
    let parsedPoints = point.trim().split(",");
    return {
      lat: parseFloat(parsedPoints[0]),
      lng: parseFloat(parsedPoints[1]),
      title: name,
      infoWindow: false
    };
  }

  transformPoints(points) {
    let transformedPoints = [];
    for (let i = 0; i < points.length; i++) {
      if (points[i].to !== null && points[i].to !== undefined && points[i].to !== "") {
        let icon = storeIcon;
        let complete = false;
        let infoWindow = false;
        if (points[i].status === 3) {
          icon = storeGreenIcon;
          complete = true;
        } else if (i > 0 && points[i-1].status === 3) {
          icon = storeBlueIcon;
          infoWindow = true;
        }
        transformedPoints.push(
          {...this.transformPoint(points[i].to, points[i].clients),
            icon: icon,
            complete: complete,
            infoWindow: infoWindow
          });
      }
    }
    return transformedPoints;
  }

  openMap = (ev, track) => {
    ev.preventDefault();
    axios({
      method: 'get',
      url: (this.state.tracking[track].transportCode ?
        '/api/v1/trip-tracking/tracking-locations?transportCode=' + this.state.tracking[track].transportCode :
        '/api/v1/trip-tracking/import-locations?trackingId=' + this.state.tracking[track].id),
      headers: {'Authorization': 'Bearer ' + this.props.access_token}
    })
    .then(response => {
      console.log(response.data);
      this.setState({
        showMap: true,
        mapLocations: response.data.map(
          (location, index) => (
            {
              ...location,
              infoWindow: index === response.data.length - 1
            }
          )
        ),
        mapPoints: this.transformPoints(this.state.tracking[track].tripTrackings),
        mapOrigin: this.state.tracking[track].tripTrackings[0].from ? {...this.transformPoint(
          this.state.tracking[track].tripTrackings[0].from,
          this.state.tracking[track].tripTrackings[0].clients
        ),
        icon: homeGreenIcon,
        infoWindow: false
      } : null
      });
    })
    .catch(error => {
      console.log(error);
      if (error.response) {
        logError(
          this.props.access_token,
          error.response,
          '/api/v1/trip-tracking/tracking-locations'
        );
        this.props.addNotification("Ошибка", "Danger");
      }
    });
  }

  copy() {
    document.getElementById("copy-input").select();
    document.execCommand("copy");
    this.props.addNotification("Ссылка скопирована.", "Success");
  }

  generateLink = (ev, track) => {
    axios({
      method: 'get',
      url: '/api/v1/trip-tracking/generate?' +
      (this.state.tracking[track].transportCode ?
        'transportCode=' + this.state.tracking[track].transportCode:
        'trackingId=' + this.state.tracking[track].id),
      headers: {'Authorization': 'Bearer ' + this.props.access_token}
    })
    .then(response => {
      if (!response.data) {
        this.props.addNotification("Что-то пошло не так. Пожалуйста, свяжитесь с администратором сайта.", "Danger");
      } else {
        this.props.addNotification("Ссылка сгенерирована.", "Success");
        let value = "Счастливого пути! Пожалуйста отмечайте продвижение по маршруту: " +
        window.location.origin + "/trip-tracking/tracking?" +
        (this.state.tracking[track].transportCode ? "transportCode=" + this.state.tracking[track].transportCode : "&trackingId=" + this.state.tracking[track].id ) +
        "&trTk=" + response.data;
        document.getElementById("copy-input").value = value;
        this.setState({ valueToCopy: value, showCopy: true });
      }
    })
    .catch(error => {
      console.log(error);
      setTimeout(() => this.getTripTrackings(), 1250);
      if (error.response) {
        logError(
          this.props.access_token,
          this.props.codeToMessage[error.response.status],
          '/api/v1/trip-tracking/generate?trackingId=' + this.state.tracking[track].id
        );
        this.props.addNotification(this.props.codeToMessage[error.response.status], "Danger");
      }
    });
  }

  hasManager = (managerId, tripTrackings) => {
    if (managerId === null) {
      return false;
    }
    let has = false;
    tripTrackings.forEach(tripTracking => {
      if (tripTracking &&
          tripTracking.manCodes &&
          tripTracking.manCodes.split(",").map(manCode => manCode.trim()).includes(managerId.toString())) {
        has = true;
      }
    });
    return has;
  }

  markerInfoWindow = (index, state) => {
    const updatedMarkers = [...this.state.mapLocations];
    updatedMarkers[index].infoWindow = state;
    this.setState({ mapLocations: updatedMarkers });
  }

  pointInfoWindow = (index, state) => {
    if (index > -1) {
      const updatedMarkers = [...this.state.mapPoints];
      updatedMarkers[index].infoWindow = state;
      this.setState({ mapPoints: updatedMarkers });
    } else {
      const updatedMarkers = {...this.state.mapOrigin};
      updatedMarkers.infoWindow = state;
      this.setState({ mapOrigin: updatedMarkers });
    }
  }

  render() {
    let content = (
      <div className={classes.TripTrackingLoader}>
        <div className={classes.SpinnerHolder}>
          <Spinner margin="0 auto" />
        </div>
      </div>
    );

    if (this.props.access_token === null) {
      content = <Account />;
    } else if (this.state.tracking) {
      content = (
        <Aux>
        <Modal
          modalClosed={(ev) => this.setState({ showCopy: false })}
          show={this.state.showCopy}
          style={{ width: "80%", left: "10%", top: "15%" }} >
          <textarea rows="5" id="copy-input" value={this.state.valueToCopy} style={{width: "100%"}}></textarea>
          <Button
            clicked={(ev) => this.copy()}
            extraClass={classes.ButtonClientInfo}
            btnType='Success'>
          СКОПИРОВАТЬ
          </Button>
          <Button
            clicked={(ev) => this.setState({ showCopy: false })}
            extraClass={classes.ButtonClientInfo}
            btnType='Danger'>
          ЗАКРЫТЬ
          </Button>
        </Modal>
        <TripModal
          closeCard={() => this.setState({ selectedTrip: null })}
          card={this.state.selectedTrip} />
        <TripTrackingModal
          show={this.state.showTripTrackingModal}
          closeCard={this.closeTripTrackingModal}
          tripTracking={this.state.selectedTripTracking} />
        <div className={classes.TripTracking}>
        <Modal
          modalClosed={(ev) => this.setState({ showMap: false })}
          show={this.state.showMap}
          style={{ width: "80%", left: "10%", top: "15%" }} >
          <Map
            googleMapURL={"https://maps.googleapis.com/maps/api/js?key=AIzaSyBv7FMapsW_Jj8UybXjAWhTcvC4MrOvKPs&v=3.exp&libraries=geometry,drawing,places"}
            loadingElement={<div style={{ height: `100%` }} />}
            containerElement={<div className={classes.Map} />}
            mapElement={<div style={{ height: `100%` }} />}
            mapPoints={this.state.mapPoints}
            mapOrigin={this.state.mapOrigin}
            infoWindow={(index, state) => this.markerInfoWindow(index, state)}
            pointInfoWindow={(index, state) => this.pointInfoWindow(index, state)}
            markers={this.state.mapLocations}></Map>
          <Button
            clicked={(ev) => this.setState({ showMap: false })}
            extraClass={classes.ButtonClientInfo}
            btnType='Success'>
          ЗАКРЫТЬ
          </Button>
        </Modal>
          { this.state.regions.map( region => {
              let trackings = {};
              for (let trackId in this.state.tracking) {
                if ((this.findLocationById(this.state.tracking[trackId].locationId) &&
                     this.findLocationById(this.state.tracking[trackId].locationId).region === this.state.regionToIndex[region]) ||
                    (!this.state.tracking[trackId].locationId && region === "NONE")) {
                  trackings[trackId] = [...this.state.tracking[trackId]];
                }
              }
              return (
                <div className={classes.RegionHolder}>
                  <div className={classes.RegionName}>
                    {region}
                  </div>

                  <div className={classes.RegionTrackHolder}>
                    {
                      Object.keys(trackings).length > 0 ?
                      Object.keys(trackings).reverse().map( track => {
                        if (
                          (this.props.filterManager &&
                            this.hasManager(this.props.managerId, this.state.tracking[track].tripTrackings)) ||
                            !this.props.filterManager &&
                            this.state.tracking[track].tripTrackings &&
                            this.state.tracking[track].tripTrackings.length > 1) {
                          return (
                            <Tracking
                              key={track}
                              role={this.props.role}
                              access_token={this.props.access_token}
                              onSetTripleMode={this.props.onSetTripleMode}
                              openTrip={(ev, trip, selectedTripTracking, driverId) => this.openTrip(ev, trip, selectedTripTracking, driverId)}
                              locations={this.props.locations}
                              routes={this.props.routes}
                              requests={this.props.requests}
                              openMap={(ev) => this.openMap(ev, track)}
                              generateLink={(ev) => this.generateLink(ev, track)}
                              addNotification={this.props.addNotification}
                              tripIdChanged={(ev) => this.tripIdChanged(ev, track)}
                              updateComment={(ev, index) => this.updateComment(ev, track, index)}
                              updateCrash={(ev, index) => this.updateCrash(ev, track, index)}
                              changeDate={(ev, index) => this.updateDateHandler(ev, track, index)}
                              changeTime={(ev, index) => this.updateTimeHandler(ev, track, index)}
                              changeUnloaded={(ev, index) => this.updateUnloadedHandler(ev, track)}
                              forceUnloadHandler={(ev) => this.forceUnloadHandler(track)}
                              updateAll={(ev) => this.updateTripTrackingStatus(this.state.tracking[track], track)}
                              tripTrackingStatus={this.state.tracking[track]}
                              updateStatusHandler={(ev, status, index) => this.updatePointStatusHandler(ev, track, status, index)}
                             />
                          )
                        } else {
                          return null;
                        }
                      } )
                      : <div className={classes.EmptyRegion}><em>Нет машин для отслеживания</em></div>
                    }
                  </div>
                </div>
              );
            } ) }

        </div>
        </Aux>
      );
    }

    return (
      <Aux>
        { content }
      </Aux>
    );
  }
}

const mapStateToProps = state => {
  return {
    access_token: state.access_token,
    routes: state.routes,
    requests: state.requests,
    locations: state.locations,
    role: state.role,
    codeToMessage: state.codeToMessage,
    filterManager: state.filterManager,
    managerId: state.managerId
  };
}

const mapDispatchToProps = dispatch => {
  return {
    addNotification: (notification, notificationType) => dispatch({ type: actionTypes.ADD_NOTIFICATION,
                                                                   notification: notification,
                                                                   notificationType: notificationType }),
    onSetTripleMode: (tripleMode) => dispatch({ type: actionTypes.SET_TRIPLE_MODE,
                                                tripleMode: tripleMode}),
    onSetRoutes: (routes) => dispatch({ type: actionTypes.ROUTES, routes: routes }),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TripTracking);



// WEBPACK FOOTER //
// ./src/containers/TripTracking/TripTracking.js